var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: "12", "no-margin": "" } },
    [
      _vm._l(_vm.filter.Values, function (val, i) {
        return _c(
          "w-row",
          { key: i, attrs: { "no-margin": "" } },
          [
            _c("app-human-filter-edit-value-default-single-value", {
              attrs: {
                filter: _vm.filter,
                label: _vm.getLabel(i),
                "field-type": _vm.fieldType,
                model: _vm.model,
                "value-index": i,
                "disable-use-value-of-other-field":
                  _vm.disableUseValueOfOtherField,
              },
            }),
          ],
          1
        )
      }),
      _c(
        "w-row",
        [
          _vm.valueAmount == -1
            ? _c(
                "w-col",
                { attrs: { xs: "6", md: "6" } },
                [
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addValue()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("add-value")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }